import type { IMarketPricing } from "../store/useMarketPricing";

/**
 * The materials the Revenues page charts count, as the backend does: weighed
 * ones per kg and counted ones per item, never statiegeld (it runs on
 * deposits).
 */
export const isRevenueMaterial = (
  material: Pick<IMarketPricing, "measurement" | "dropType">
): boolean =>
  (material.measurement === "kg" || material.measurement === "unit") &&
  material.dropType !== "statiegeld";

/** The names for a Revenues chart's Material filter, sorted. */
export const revenueMaterialNames = (
  marketPrices: IMarketPricing[] | null | undefined
): string[] =>
  Array.from(
    new Set((marketPrices ?? []).filter(isRevenueMaterial).map((m) => m.name))
  ).sort();
